import * as _ from 'lodash';
import sidebarLinksJSON from "../FackApi/json/SideBar.json"
export const userSidebarLinks = (userData, UserPermissions, isBusinessOwner) => {
  let userClaims = UserPermissions
    .filter(p => p.endsWith('.read'))
    .map(p => {
      const parts = p.split('.');
      const module = parts[2];
      if (!module) return null;
      return module.toLowerCase();
    })
    .filter(Boolean);
    userClaims.push('dashboard');
    if (isBusinessOwner) userClaims.push('permissions');
    
    userClaims = _.uniq(userClaims);

  return _.filter(sidebarLinksJSON, l => userClaims.includes(l.title.toLowerCase()));
};
